"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GTMHeader = void 0;
var react_1 = __importDefault(require("react"));
var script_1 = __importDefault(require("next/script"));
var GTMHeader = function (_a) {
    var gtmID = _a.gtmID;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(script_1.default, { id: "gtm-script-header", strategy: "beforeInteractive", dangerouslySetInnerHTML: {
                __html: "\n          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n          })(window,document,'script','dataLayer','".concat(gtmID, "');\n        "),
            } })));
};
exports.GTMHeader = GTMHeader;
